export default __webpack_public_path__ + "static/media/perso-wi.9d00d4dd.png";